import { Box, IconButton, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import useYourData from './useYourData';

const PAGE_SIZE = 25;

/**
 * YourDataPager
 *
 * Prev/next pager for navigating pages of the active topic's entries.
 * Same layout convention as YourNotesNodePager — page indicator
 * between two chevron buttons. No "hide completed" control here —
 * YourDataTab already owns that toggle in its own info row.
 */
export default function YourDataPager() {
    const { total, currentPage, loadPage } = useYourData();

    const totalPages = Math.ceil(total / PAGE_SIZE) || 1;

    // Calculates next page and delegates to engine — no BL, guard only for out-of-range
    const handlePage = (direction) => {
        const next = currentPage + direction;
        if (next < 1 || next > totalPages) return;
        loadPage(next);
    };

    return (
        <Box
            id="your-data-pager"
            className="your-data-pager"
            sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '2px', px: 1 }}
        >
            <IconButton size="small" onClick={() => handlePage(-1)} disabled={currentPage <= 1} sx={{ color: '#a3d1ff' }}>
                <ChevronLeft fontSize="small" />
            </IconButton>
            <Typography variant="caption" sx={{ color: '#a3d1ff', fontSize: '11px', whiteSpace: 'nowrap' }}>
                {currentPage} / {totalPages}
            </Typography>
            <IconButton size="small" onClick={() => handlePage(1)} disabled={currentPage >= totalPages} sx={{ color: '#a3d1ff' }}>
                <ChevronRight fontSize="small" />
            </IconButton>
        </Box>
    );
}
